$('.switch--wrapper').each(function () {
    var tabs = $(this);

    $(tabs).find('.tab--link').click(function () {
        var tabID = $(this).attr('data-tab');

        $(this).addClass('active');
        $(this).siblings().removeClass('active');
    
        $(tabs).find('#tab-' + tabID).siblings().removeClass('active');
        $(tabs).find('#tab-' + tabID).addClass('active');
    })
});